import React from "react";

const ResultDiv = (props) => {
  return (
    <div className="mb-4" dangerouslySetInnerHTML={{ __html: props.text }} />
  );
};

export default ResultDiv;
